"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeUtmParams = removeUtmParams;
function removeUtmParams(link) {
  try {
    const url = new URL(link);
    const keysToDelete = [];
    for (const key of url.searchParams.keys()) {
      if (key.startsWith('utm_')) {
        keysToDelete.push(key);
      }
    }
    for (const key of keysToDelete) {
      url.searchParams.delete(key);
    }
    return url.toString();
  } catch (error) {
    return link;
  }
}
